import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from '@mui/material'

const PASSOS = [
  'Abra este endereço no Safari (no Chrome do iPhone também funciona).',
  'Toque em Compartilhar: o quadrado com a seta para cima, na barra do navegador.',
  'Role as opções e toque em "Adicionar à Tela de Início".',
  'Confirme em "Adicionar". O ícone do MarketingHUB aparece na tela inicial.',
]

/** Como instalar no iPhone e no iPad, onde o navegador não oferece um botão de instalar. */
export function InstalarAppDialog({ aberto, onFechar }: { aberto: boolean; onFechar: () => void }) {
  return (
    <Dialog open={aberto} onClose={onFechar} fullWidth maxWidth="xs">
      <DialogTitle>Instalar no iPhone</DialogTitle>
      <DialogContent>
        <Stack spacing={1.5}>
          {PASSOS.map((p, i) => (
            <Stack key={p} direction="row" spacing={1.5} alignItems="flex-start">
              <Box
                sx={{
                  flexShrink: 0,
                  width: 24,
                  height: 24,
                  borderRadius: '50%',
                  bgcolor: 'primary.main',
                  color: 'primary.contrastText',
                  display: 'grid',
                  placeItems: 'center',
                  fontSize: 13,
                  fontWeight: 700,
                }}
              >
                {i + 1}
              </Box>
              <Typography variant="body2">{p}</Typography>
            </Stack>
          ))}
          <Typography variant="body2" color="text.secondary">
            Aberto pelo ícone, ele ocupa a tela toda, sem a barra do navegador. O login é feito uma vez dentro do app.
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onFechar} sx={{ textTransform: 'none' }}>
          Entendi
        </Button>
      </DialogActions>
    </Dialog>
  )
}
